import { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Content,
  Heading,
  Form,
  TextField,
  TextArea,
  ButtonGroup,
  Button,
  Dialog,
} from "@react-spectrum/s2";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const NewCampaignDialog = ({ defaultCampaign, onClose, onSuccess }) => {
  const [title, setTitle] = useState(defaultCampaign?.title || "");
  const [description, setDescription] = useState(
    defaultCampaign?.description || "",
  );
  const [tagline, setTagline] = useState(defaultCampaign?.tagline || "");
  const [landingPageUrl, setLandingPageUrl] = useState(
    defaultCampaign?.landingPageURL || "",
  );
  const isSubmitDisabled = !title.trim() || !tagline.trim();

  useEffect(() => {
    setTitle(defaultCampaign?.title || "");
    setDescription(defaultCampaign?.description || "");
    setTagline(defaultCampaign?.tagline || "");
    setLandingPageUrl(defaultCampaign?.landingPageURL || "");
  }, [defaultCampaign]);

  const handleSubmit = useCallback(
    (close) => {
      onSuccess?.({
        ...(defaultCampaign ?? {}),
        title: title,
        description: description,
        tagline: tagline,
        landingPageURL: landingPageUrl,
      });

      setTitle("");
      setDescription("");
      setTagline("");
      setLandingPageUrl("");

      close();
    },
    [onSuccess, title, description, tagline, landingPageUrl],
  );

  return (
    <Dialog>
      {({ close }) => (
        <>
          <Heading slot="title">
            {defaultCampaign?.id ? "Edit campaign" : "Add new campaign"}
          </Heading>
          <Content>
            <Form>
              <TextField
                label="Title"
                value={title}
                isRequired
                onChange={setTitle}
              />
              <TextArea
                label="Description"
                value={description}
                onChange={setDescription}
              />
              <TextField
                label="Tagline"
                value={tagline}
                onChange={setTagline}
                isRequired
              />
              <TextField
                label="Landing Page URL"
                value={landingPageUrl}
                onChange={setLandingPageUrl}
              />
            </Form>
          </Content>
          <ButtonGroup styles={style({ marginTop: 32 })}>
            <Button
              variant="secondary"
              onPress={() => (onClose ? onClose?.(close) : close())}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              isDisabled={isSubmitDisabled}
              onPress={() => handleSubmit(close)}
            >
              {!!defaultCampaign ? "Edit" : "Add"}
            </Button>
          </ButtonGroup>
        </>
      )}
    </Dialog>
  );
};

NewCampaignDialog.propTypes = {
  defaultCampaign: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    tagline: PropTypes.string,
    landingPageURL: PropTypes.string,
  }),
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
